import React from 'react';
import './accessdenied.css';
import { useNavigate } from 'react-router-dom';
import Nav from '../components/layout/nav';
const AccessDenied = () => {
  const navigate = useNavigate();

  return (
     <div className='dashboard'>

            <Nav />

            <div className='mainarea'>

                <div className='navtoppart'>

                    <div className='welcomebcakdiv'>
                        <h6 className='welcomebacktext'>Welcome back</h6>
                        <h6 className='admintitle'>Admin Dashboard</h6>
                    </div>

                    <div className='profileandnotidiv'>
                        <div className='notidiv'>
                            <div className='notiicon'></div>
                        </div>
                        <div className='profilediv'></div>
                    </div>

                </div>
                <div className='pagecenter'>

                    <div className='homecontainer'>

                        <section>
                           
                            <div className="accesspage">

                                <div className="accesscard">

                                    <div className="icon">-</div>

                                    <h1>Access Denied</h1>

                                    <p>
                                    You don’t have permission to view this page.
                                    Please log in with an authorized account.
                                    </p>

                                    <div className="buttons">

                                    <button onClick={() => navigate('/login')}>
                                        Go to Login
                                    </button>

                                    <button onClick={() => navigate('/overview')}>
                                        Home
                                    </button>

                                    </div>

                                </div>

                                </div>

                           
                        </section>
                            
                    </div>
                        
                </div>
                
               
            </div>

        </div>
  
  );
};

export default AccessDenied;